
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-chat-button",
      function () {
        return require("private-next-pages/whatsapp-chat-button.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-chat-button"])
      });
    }
  